import { AppThunk } from '../../../../../store/types';
import { ContentLibActions } from '../../../../../store/contentLib/actions';
import { EContentLibViewMode } from '../../../../../store/contentLib/types';
import { setCreatePlaylistModalOpenAction, setMainViewMode } from '../../../../../store/general/actions';
import { EMainViewMode } from '../../../../../store/general/types';
import { Navigator } from '../../../../../effects/navigator';

export class ContentLibraryHeaderEvents {

  public static onChangeViewMode(viewMode: EContentLibViewMode): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      if (viewMode === EContentLibViewMode.PHRASES) {
        dispatch(setMainViewMode(EMainViewMode.PHRASES));
        setTimeout(()=>Navigator.openDefault());
      } else {
        dispatch(ContentLibActions.setViewMode(viewMode));
      }
    }
  }

  public static onShowAddPlayList(
    ): AppThunk {
      return async (
        dispatch,
        getState
      ) => {
        dispatch(setCreatePlaylistModalOpenAction(true))
      }
    }


}